// Keep native variant updates and linked product navigation unchanged.
const pickerSelector = ".product-info__variant-picker, .product-info__product-picker";
const pending = new Map();

function clearLoading(picker) {
  const state = pending.get(picker);
  if (!state) return;

  clearTimeout(state.timeout);
  picker.classList.remove("is-color-loading");
  state.swatch.classList.remove("is-color-loading");
  if (state.busy === null) picker.removeAttribute("aria-busy");
  else picker.setAttribute("aria-busy", state.busy);
  pending.delete(picker);
}

function showLoading(swatch, formId = null) {
  const picker = swatch.closest(pickerSelector);
  if (!picker) return;

  clearLoading(picker);
  const busy = picker.getAttribute("aria-busy");
  picker.classList.add("is-color-loading");
  picker.setAttribute("aria-busy", "true");
  swatch.classList.add("is-color-loading");
  pending.set(picker, {
    swatch,
    formId,
    busy,
    // Recover if navigation is cancelled or a variant request fails.
    timeout: setTimeout(() => clearLoading(picker), 15000)
  });
}

document.addEventListener("click", (event) => {
  if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const swatch = event.target.closest("a.color-swatch[href]");
  if (!swatch || swatch.hasAttribute("download") || (swatch.target && swatch.target !== "_self")) return;
  showLoading(swatch);
});

document.addEventListener("change", (event) => {
  const input = event.target;
  if (!input.matches('input[type="radio"][data-option-position]') || !input.checked || input.disabled) return;
  const swatch = Array.from(input.labels || []).find((label) => label.matches(".color-swatch"));
  if (swatch) showLoading(swatch, input.form?.id);
});

function finishVariantUpdate(event) {
  const formId = event.detail?.formId || event.target.id;
  for (const [picker, state] of pending) {
    if (state.formId && state.formId === formId) clearLoading(picker);
  }
}

// product:rerender does not bubble; capture also handles product-changing variants.
document.addEventListener("product:rerender", finishVariantUpdate, true);
document.addEventListener("variant:change", finishVariantUpdate);
window.addEventListener("pageshow", () => {
  for (const picker of pending.keys()) clearLoading(picker);
});
